module.exports = __webpack_public_path__ + "static/bg (2)-fc39d49e3ebe6cddd30b990a5894c6a7.jpg";